const en_us = {
    values: {
        'Database management': 'Database management',
        Data: 'Data',
        Query: 'Query',
        Queries: 'Queries',
        Addresses: 'Addresses',
        Address: 'Address',
        'server:port': 'server:port',
        'comma separated': 'comma separated',
        'Read-only': 'Read-only',
        cancelled: 'cancelled',
        running: 'running',
        completed: 'completed',
        'No slow, running or completed queries': 'No slow, running or completed queries',
        'Explain query': 'Explain query',
        'Explained query available': 'Explained query available',
        'Processing. It could take some time.': 'Processing. It could take some time.',
        'Explain Results': 'Explain Results',
        'No index found on this collection': 'No index found on this collection',
        'Delete collection': 'Delete collection',
        Delete: 'Delete',
        'If you really want to delete the collection, type': 'If you really want to delete the collection, type',
        'All data on this collection will be lost': 'All data on this collection will be lost',
        'Are you sure you want to delete the collection': 'Are you sure you want to delete the collection',
        Documents: 'Documents',
        'Size on disk': 'Size on disk',
        Sparse: 'Sparse',
        Usual: 'Usual',
        Partial: 'Partial',
        Type: 'Type',
        Index: 'Index',
        Collection: 'Collection',
        Collections: 'Collections',
        'No collections': 'No collections',
        'Create Index': 'Create Index',
        'Create index here': 'Create index here',
        'Delete index': 'Delete index',
        'If you really want to delete the index, type': 'If you really want to delete the index, type',
        'This action does not erase data, but it can affect datasources, rules and dashboards':
            'This action does not erase data, but it can affect datasources, rules and dashboards',
        'from the collection': 'from the collection',
        'Are you sure you want to delete the index': 'Are you sure you want to delete the index',
        default: 'default',
        custom: 'custom',
        Create: 'Create',
        'Hint: it could take some time to index all the data from selected collections. During this process, index size will increase quickly and system performance can be affected.':
            'Hint: it could take some time to index all the data from selected collections. During this process, index size will increase quickly and system performance can be affected.',
        'You must choose at least one collection': 'You must choose at least one collection',
        'Add this index to the following collections': 'Add this index to the following collections',
        'Index expression': 'Index expression',
        'Index name': 'Index name',
        'Create index': 'Create index',
        'Index name must not be empty': 'Index name must not be empty',
        'Choose collection': 'Choose collection',
        'Hide default indexes': 'Hide default indexes',
        'No custom indexes. %{trivialIndexes} default indexes hidden.': [
            [1, 1, 'No custom indexes. There is one default index hidden.'],
            [2, null, 'No custom indexes. %n default indexes hidden.']
        ],
        'Index Type': 'Index Type',
        "Doesn't index documents that don't contain the indexed fields":
            "Doesn't index documents that don't contain the indexed fields",
        'The filter must be in Pipes format. Leave the box empty for "no filter".':
            'The filter must be in Pipes format. Leave the box empty for "no filter".',
        yes: 'yes',
        no: 'no',
        'Non-indexable': 'Non-indexable',
        'ADD NEW ADDRESS': 'ADD NEW ADDRESS',
        'Only alphanumeric and underscore are allowed': 'Only alphanumeric and underscore are allowed',
        'Snappy compression': 'Snappy compression',
        'used with server versions 3.4 and greater': 'used with server versions 3.4 and greater',
        'Zlib compression': 'Zlib compression',
        'used with server versions 3.6 and greater': 'used with server versions 3.6 and greater',
        'HTTP status': 'HTTP status',
        'Server side failure': 'Server side failure',
        'MongoDB seems not available at the moment, please check the integration configuration.':
            'MongoDB seems not available at the moment, please check the integration configuration.',
        'Failure to list MongoDB queries': 'Failure to list MongoDB queries',
        'Failure to probe MongoDB query explainer': 'Failure to probe MongoDB query explainer',
        "Failure to list MongoDB collection' names": "Failure to list MongoDB collection' names",
        'Failure to list MongoDB collections': 'Failure to list MongoDB collections',
        'Failure to delete MongoDB collection': 'Failure to delete MongoDB collection',
        'Failure to create MongoDB indexes': 'Failure to create MongoDB indexes',
        'Failure to delete MongoDB indexes': 'Failure to delete MongoDB indexes',
        'Password change not saved': 'Password change not saved',
        Username: 'Username',
        'Replica Set': 'Replica Set',
        Filter: 'Filter',
        'Authentication Database': 'Authentication Database',
        Database: 'Database',
        'Write Concern': 'Write Concern',
        'Read Preference': 'Read Preference',
        'Search by collections or event types...': 'Search by collections or event types...',
        'Latest updated: ': 'Latest updated: ',
        'Gathering collection stats...': 'Gathering collection stats...',
        'Showing %{showNumber} of %{collectionNumber} collections':
            'Showing %{showNumber} of %{collectionNumber} collections',
        'Load more': 'Load more',
        'All indexes': 'All indexes',
        'Custom indexes': 'Custom indexes',
        'Missing timestamp index': 'Missing timestamp index',
        'The database name cannot be empty': 'The database name cannot be empty',
        'The address cannot be empty': 'The address cannot be empty',
        MongoDB_InstanceForm_FollowRangeFieldRule_Switch_Label:
            'Index management based on ESR (Equality, Sort, Range) rules',
        MongoDB_InstanceForm_FollowRangeFieldRule_Switch_Tooltip:
            'This option ensures the indexes managed by Live will be created by moving the first field into the end ' +
            'of the index properties chain. This typically will help to adhere to the Sort and Range constraints. Recommended: always enable it for new installations. For environments which already have HUGE datasets, keep it DISABLED until you have migrated all indexes for the ESR format.',
        'Remember to follow the': 'Remember to follow the',
        'ESR rule': 'ESR rule',
        'when creating indexes': 'when creating indexes',
        'See error details': 'See error details',
        'Error details': 'Error details',
        or: 'or',
        Dismiss: 'Dismiss',
        'Count cache eviction time (per storage query)': 'Count cache eviction time (per storage query)',
        'Collection compression': 'Collection compression'
    }
}

module.exports = en_us
